module.exports = __webpack_public_path__ + "img/shadow-websocket-200X144.eb3da9b4.png";